// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_wrk_api = require("./MM_wrk_api.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.bs.js");

var WorkerException = /* @__PURE__ */Caml_exceptions.create("MM_wrk_client.WorkerException");

var webworkerRef = {
  contents: undefined
};

function terminateWorker(param) {
  var webworker = webworkerRef.contents;
  if (webworker !== undefined) {
    Caml_option.valFromOption(webworker).terminate();
    webworkerRef.contents = undefined;
    return ;
  }
  
}

var nextClientId = {
  contents: 0
};

function getNextClientId(param) {
  nextClientId.contents = nextClientId.contents + 1 | 0;
  return nextClientId.contents - 1 | 0;
}

var clients = [];

function regClient(callback, enableTrace) {
  var id = getNextClientId(undefined);
  clients.push({
        id: id,
        callback: callback,
        traceEnabled: enableTrace
      });
  return id;
}

function beginWorkerInteraction(procName, initialRequest, onResponse, enableTraceOpt, reqToStr, respToStr, param) {
  var enableTrace = enableTraceOpt !== undefined ? enableTraceOpt : false;
  var id = {
    contents: -1
  };
  var localSendToWorker = {
    contents: (function (param) {
        
      })
  };
  id.contents = regClient((function (respBody) {
          var resp = MM_wrk_api.deserialize(respBody);
          if (enableTrace) {
            MM_wrk_api.logClientReceivedResponse(id.contents, procName, resp, respToStr);
          }
          Curry._3(onResponse, resp, localSendToWorker.contents, (function (param) {
                  var id$1 = id.contents;
                  var i = 0;
                  while(i < clients.length) {
                    if (Caml_array.get(clients, i).id === id$1) {
                      clients.splice(i, 1);
                    } else {
                      i = i + 1 | 0;
                    }
                  };
                }));
        }), enableTrace);
  localSendToWorker.contents = (function (req) {
      if (enableTrace) {
        MM_wrk_api.logClientIsSendingRequest(id.contents, procName, req, reqToStr);
      }
      var req$1 = {
        clientId: id.contents,
        procName: procName,
        body: MM_wrk_api.serialize(req),
        traceEnabled: enableTrace
      };
      if (Belt_Option.isNone(webworkerRef.contents)) {
        var webworker = new Worker("./webworker-main.js");
        webworker.onmessage = (function (msg) {
            var resp = msg.data;
            Expln_utils_common.arrForEach(clients, (function (client) {
                    if (client.id === resp.clientId) {
                      Curry._1(client.callback, resp.body);
                      return Caml_option.some(undefined);
                    }
                    
                  }));
          });
        webworkerRef.contents = Caml_option.some(webworker);
      }
      var webworker$1 = webworkerRef.contents;
      if (webworker$1 !== undefined) {
        return Caml_option.valFromOption(webworker$1).postMessage(req$1);
      }
      throw {
            RE_EXN_ID: WorkerException,
            _1: "Could not instantiate a webworker.",
            Error: new Error()
          };
    });
  Curry._1(localSendToWorker.contents, initialRequest);
}

exports.beginWorkerInteraction = beginWorkerInteraction;
exports.terminateWorker = terminateWorker;
/* MM_wrk_api Not a pure module */
